'use strict';

/**
 * POST commands to YouTube or Vimeo API
 * @param {string} player - Player selector
 * @param {string} command - Command to player
 */
var postMessageToPlayer = function (player, command) {
    if (player == null || command == null) return;
    var content = player.contentWindow;
    content.postMessage(JSON.stringify(command), '*');
};

/**
 * Play or Pause video when the slide is changing
 * @param {string} slide - the slide to handle
 * @param {string} control -  Video host
 */
var playPauseVideo = function (slide, control) {
    var $currentSlide = $(slide);
    var $videoComponent = $($currentSlide).find('.video-component');
    // only handle Video slides
    if ($videoComponent.length === 0) {
        return;
    }
    // get the video slide type
    var slideType = $($currentSlide).find('.video-component').attr('class').split(' ')[0].trim();

    var videoCommand = {
        vimeo: {
            play: function () {
                var player = $currentSlide.find('iframe').get(0);
                var startTime = $currentSlide.data('video-start');
                if ((startTime != null && startTime > 0) && !$currentSlide.hasClass('started')) {
                    $currentSlide.addClass('started');
                    postMessageToPlayer(player, {
                        method: 'setCurrentTime',
                        value: startTime
                    });
                }
                postMessageToPlayer(player, {
                    method: 'play',
                    value: 1
                });
                $videoComponent.removeClass('paused');
            },
            pause: function () {
                var player = $currentSlide.find('iframe').get(0);
                postMessageToPlayer(player, {
                    method: 'pause',
                    value: 1
                });
                $videoComponent.addClass('paused');
            }
        },
        youtube: {
            play: function () {
                var player = $currentSlide.find('iframe').get(0);
                postMessageToPlayer(player, {
                    event: 'command',
                    func: 'playVideo'
                });
                $videoComponent.removeClass('paused');
            },
            pause: function () {
                var player = $currentSlide.find('iframe').get(0);
                postMessageToPlayer(player, {
                    event: 'command',
                    func: 'pauseVideo'
                });
                $videoComponent.addClass('paused');
            }
        },
        video: {
            play: function () {
                var video = $currentSlide.find('video').get(0);
                if (video != null) {
                    video.play();
                }
                $videoComponent.removeClass('paused');
            },
            pause: function () {
                var video = $currentSlide.find('video').get(0);
                if (video != null) {
                    video.pause();
                }
                $videoComponent.addClass('paused');
            }
        }
    };

    if (slideType !== null && slideType in videoCommand) {
        videoCommand[slideType][control]();
    }
};

/**
 * Initialize video controls for slick slider videos
 * @param {string} slideWrapper - Slick slider to target
 */
var videoControlsInit = function (slideWrapper) {
    // Initialize
    // auto pause all slides in case any videos with sound are included.
    var $filteredSlides = $(slideWrapper).find('.slick-slide').filter(':not(.slick-current)');
    $filteredSlides.each(function (idx) {
        playPauseVideo($filteredSlides[idx], 'pause');
    });

    // play the first slide
    var $currentSlide = slideWrapper.find('.slick-current');
    playPauseVideo($currentSlide, 'play');

    slideWrapper.on('click', function (slick) {
        $currentSlide = $(slick.currentTarget);
        if ($currentSlide.find('.video-component').hasClass('paused')) {
            playPauseVideo($currentSlide, 'play');
        } else {
            playPauseVideo($currentSlide, 'pause');
        }
    });
    slideWrapper.on('beforeChange', function (event, slick) {
        var slickBefore = $(slick.$slides[slick.currentSlide]);
        playPauseVideo(slickBefore, 'pause');
    });
    slideWrapper.on('afterChange', function (event, slick) {
        var slickAfter = $(slick.$slides[slick.currentSlide]);
        playPauseVideo(slickAfter, 'play');
    });
};

var videoUtils = {
    postMessageToPlayer: postMessageToPlayer,
    playPauseVideo: playPauseVideo,
    videoControlsInit: videoControlsInit
};

module.exports = videoUtils;
